import { Action, createReducer, on } from '@ngrx/store';
import { Product, ProductDTO, ProductsFilters } from '../../commons/models/product';
import * as ProductsActions from '../actions/products.actions';

export interface ProductState {
    list: ProductDTO[],
    total: number,
    includes: string[],
    currentPage: number,
    perPage: number,
    order: string,
    direction: string,
    filters: ProductsFilters,
    products: ProductDTO,
    dialogId: string,
    selectionDialogId: string,
    selectedProducts: Product[]
};

const initialState: ProductState = {
    list: [],
    total: 0,
    includes: [],
    currentPage: 1,
    perPage: 25,
    order: null,
    direction: null,
    filters: null,
    products: null,
    dialogId: null,
    selectionDialogId: null,
    selectedProducts: []
};

const productsReducer = createReducer(
  initialState,
  on(ProductsActions.loadProductsCompleted, (state, { product, currentPage, total, perPage, order, direction, filters, includes }) => {
    return { ...state, list: product, currentPage, total, perPage, order, direction, filters, includes };
  }),

    on(ProductsActions.productDialogOpened, (state, {dialogId}) => {
      return { ...state, dialogId };
  }),

);

export function reducer(state: ProductState | undefined, action: Action){
    return productsReducer(state, action);
}
